/**
 * Helpers compartilhados para rótulo/duração do nó Intervalo do Flow Builder.
 */

export const MAX_INTERVAL_SECONDS = 24 * 60 * 60;

export const formatIntervalLabel = (sec) => {
  const s = Number(sec) || 0;
  if (s <= 0) return "Aguardar...";
  if (s >= 3600 && s % 3600 === 0) {
    const h = s / 3600;
    return `${h} hora${h !== 1 ? "s" : ""}`;
  }
  if (s >= 60 && s % 60 === 0) {
    const m = s / 60;
    return `${m} minuto${m !== 1 ? "s" : ""}`;
  }
  if (s >= 3600) {
    const h = Math.floor(s / 3600);
    const m = Math.round((s % 3600) / 60);
    if (m === 0) return `${h} hora${h !== 1 ? "s" : ""}`;
    return `${h}h ${m}min`;
  }
  if (s >= 60) {
    const m = Math.floor(s / 60);
    const rest = s % 60;
    if (rest === 0) return `${m} minuto${m !== 1 ? "s" : ""}`;
    return `${m}min ${rest}s`;
  }
  return `${s} segundo${s !== 1 ? "s" : ""}`;
};
